import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';

function SiteMetadata(_ref) {
  var siteMetadata = _ref.siteMetadata;
  return React.createElement(Helmet, null, siteMetadata.title && React.createElement("title", null, siteMetadata.title), siteMetadata.description && React.createElement("meta", {
    name: "description",
    content: siteMetadata.description
  }), siteMetadata.keywords && React.createElement("meta", {
    name: "keywords",
    content: siteMetadata.keywords
  }));
}

SiteMetadata.propTypes = {
  siteMetadata: PropTypes.shape({
    title: PropTypes.string,
    description: PropTypes.string,
    keywords: PropTypes.string
  }).isRequired
};
export default SiteMetadata;